import { action, observable, makeObservable } from 'mobx';
import { Model, IModelAttributes, attribute, entity } from 'Models/Model';

export interface IEmailTemplateEntityAttributes extends IModelAttributes {
	key: string;
	displayName: string;
	template: string;
	subjectName: string;
	jsonTemplate: string;
}
@entity('EmailTemplateEntity', 'Email Template')
export default class EmailTemplateEntity extends Model implements IEmailTemplateEntityAttributes {
	/**
	 * Fields to exclude from the JSON serialization in create operations.
	 */
	public static excludeFromCreate: string[] = [];

	/**
	 * Fields to exclude from the JSON serialization in update operations.
	 */
	public static excludeFromUpdate: string[] = [];

	@observable
	@attribute()
	public key: string;

	@observable
	@attribute<EmailTemplateEntity, string>()
	public displayName: string;

	@observable
	@attribute()
	public template: string;

	@observable
	@attribute<EmailTemplateEntity, string>()
	public subjectName: string;

	@observable
	@attribute<EmailTemplateEntity, string>()
	public jsonTemplate: string;

	constructor(attributes?: Partial<IEmailTemplateEntityAttributes>) {
		super(attributes);

		makeObservable(this);

		this.assignAttributes(attributes);
	}

	/**
	 * Assigns fields from a passed in JSON object to the fields in this model.
	 * Any reference objects that are passed in are converted to models if they are not already.
	 * This function is called from the constructor to assign the initial fields.
	 */
	public assignAttributes(attributes?: Partial<IEmailTemplateEntityAttributes>) {
		super.assignAttributes(attributes);

		if (attributes) {
			if (attributes.key !== undefined) {
				this.key = attributes.key;
			}
			if (attributes.displayName !== undefined) {
				this.displayName = attributes.displayName;
			}
			if (attributes.template !== undefined) {
				this.template = attributes.template;
			}
			if (attributes.subjectName !== undefined) {
				this.subjectName = attributes.subjectName;
			}
			if (attributes.jsonTemplate !== undefined) {
				this.jsonTemplate = attributes.jsonTemplate;
			}
		}
	}
}
